<div class="week-head">
    <p><span>{{ currentWeek }}</span></p>
  </div>
  